import { useEffect, useRef, useState } from 'react';

import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { FloatButton } from 'antd';
import cn from 'classnames';

import s from './HorizontalScrollWithArrows.module.scss';

// We'll define fade styles here

const SCROLL_AMOUNT = 550;

const HorizontalScrollWithArrows = ({ children }) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);

  const checkScroll = () => {
    const el = scrollRef.current;
    if (!el) return;

    setShowLeft(el.scrollLeft > 0);
    setShowRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
  };

  const scrollBy = (amount: number) => {
    scrollRef.current?.scrollBy({ left: amount, behavior: 'smooth' });
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    checkScroll();
    el.addEventListener('scroll', checkScroll);
    window.addEventListener('resize', checkScroll);

    return () => {
      el.removeEventListener('scroll', checkScroll);
      window.removeEventListener('resize', checkScroll);
    };
  }, []);

  return (
    <div style={{ position: 'relative', overflow: 'hidden' }}>
      {/* Fade Masks */}
      {showLeft && <div className={cn(s.fadeMask, s.left)}></div>}
      {showRight && <div className={cn(s.fadeMask, s.right)}></div>}

      {/* Arrows */}
      {showLeft && (
        <FloatButton
          shape="circle"
          icon={<LeftOutlined />}
          onClick={() => scrollBy(-SCROLL_AMOUNT)}
          style={{
            position: 'absolute',
            left: 0,
            top: '50%',
            borderRadius: '50%',
            transform: 'translateY(-50%)',
            zIndex: 2,
          }}
        />
      )}
      <div
        ref={scrollRef}
        style={{
          overflowX: 'auto',
          whiteSpace: 'nowrap',
          scrollBehavior: 'smooth',
        }}>
        {children}
      </div>
      {showRight && (
        <FloatButton
          shape="circle"
          icon={<RightOutlined />}
          onClick={() => scrollBy(SCROLL_AMOUNT)}
          style={{
            position: 'absolute',
            right: 0,
            top: '50%',
            borderRadius: '50%',
            transform: 'translateY(-50%)',
            zIndex: 2,
          }}
        />
      )}
    </div>
  );
};

export default HorizontalScrollWithArrows;
